import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-related-articles',
  templateUrl: './related-articles.component.html',
  styleUrls: ['./../app.component.css']
})
export class RelatedArticlesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
